import { ref, onMounted, onUnmounted } from "vue";

export function useScreenSize() {
  const vssWidth = ref(window.innerWidth);

  const updateWidth = () => {
    vssWidth.value = window.innerWidth;
  };

  onMounted(() => {
    window.addEventListener("resize", updateWidth);
  });

  onUnmounted(() => {
    window.removeEventListener("resize", updateWidth);
  });

  return {
    vssWidth,
  };
}
